import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

const Page404 = () => import('@/views/pages/Page404');

Vue.use(Router);

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/login',
      meta: {
        authorized: false
      },
      name: 'Auth',
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          meta: {
            authorized: false
          },
          component: () => {
            return import(
              /* webpackChunkName: "Auth.Login" */ '@/views/pages/Login.vue'
            );
          }
        },
        {
          path: '/forgot-password',
          name: 'ForgotPassword',
          meta: {
            authorized: false
          },
          component: () => {
            return import(
              /* webpackChunkName: "Auth.ForgotPassword" */ '@/views/pages/ForgotPassword.vue'
            );
          }
        },
        {
          path: '/resetPassword/:userid/:token',
          name: 'ResetPassword',
          meta: {
            authorized: false
          },
          component: () => {
            return import(
              /* webpackChunkName: "Auth.ResetPassword" */ '@/views/pages/ResetPassword.vue'
            );
          }
        }
      ]
    },

    {
      path: '/',
      component: DefaultContainer,
      children: [
        /* Projects */
        {
          path: 'admin/projects',
          name: 'Admin.Projects.Index',
          meta: {
            label: 'Projects',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Projects.Index" */ '@/views/pages/integrations/projects/Index'
            );
          }
        },
        {
          path: 'admin/projects/create',
          name: 'Admin.Projects.Create',
          meta: {
            label: 'Create Project',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Projects.Form" */ '@/views/pages/integrations/projects/Form'
            );
          }
        },
        {
          path: 'admin/projects/edit/:id',
          name: 'Admin.Projects.Edit',
          props: true,
          meta: {
            label: 'Edit Project',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Projects.Form" */ '@/views/pages/integrations/projects/Form'
            );
          }
        },

        /* Docs */
        {
          path: '/docs/knowledgebase/pages',
          name: 'Admin.Knowledgebase.Pages.Index',
          meta: {
            label: 'Knowledgebase Pages',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Pages.Index" */ '@/views/pages/knowledgebase/pages/Index'
            );
          }
        },
        {
          path: '/docs/knowledgebase/pages/edit/:id',
          name: 'Admin.Knowledgebase.Pages.Edit',
          props: true,
          meta: {
            label: 'Knowledgebase Pages',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Pages.Form" */ '@/views/pages/knowledgebase/pages/Form'
            );
          }
        },
        {
          path: '/docs/knowledgebase/pages/create',
          name: 'Admin.Knowledgebase.Pages.Create',
          meta: {
            label: 'Knowledgebase Pages',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Pages.Form" */ '@/views/pages/knowledgebase/pages/Form'
            );
          }
        },
        {
          path: '/docs/knowledgebase/groups',
          name: 'Admin.Knowledgebase.Groups.Index',
          meta: {
            label: 'Knowledgebase Groups',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Groups.Index" */ '@/views/pages/knowledgebase/groups/Index'
            );
          }
        },
        {
          path: '/docs/knowledgebase/groups/edit/:id',
          name: 'Admin.Knowledgebase.Groups.Edit',
          props: true,
          meta: {
            label: 'Knowledgebase Groups',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Groups.Form" */ '@/views/pages/knowledgebase/groups/Form'
            );
          }
        },
        {
          path: '/docs/knowledgebase/groups/create',
          name: 'Admin.Knowledgebase.Groups.Create',
          meta: {
            label: 'Knowledgebase Groups',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Groups.Form" */ '@/views/pages/knowledgebase/groups/Form'
            );
          }
        },
        {
          path: '/docs/changelog',
          name: 'Admin.Changelog.Index',
          meta: {
            label: 'Changelog',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Changelog.Index" */ '@/views/pages/knowledgebase/changelog/Index'
            );
          }
        },
        {
          path: '/docs/changelog/edit/:id',
          name: 'Admin.Changelog.Edit',
          props: true,
          meta: {
            label: 'Changelog - Update',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Changelog.Form" */ '@/views/pages/knowledgebase/changelog/Form'
            );
          }
        },
        {
          path: '/docs/changelog/create',
          name: 'Admin.Changelog.Create',
          meta: {
            label: 'Changelog Add Entry',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Groups.Form" */ '@/views/pages/knowledgebase/changelog/Form'
            );
          }
        },
        /* public docs pages */

        {
          path: '/changelog',
          name: 'ChangelogPublic',
          meta: {
            label: 'Changelog',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "ChangelogPublic" */ '@/views/pages/knowledgebase/public/ChangelogPublic'
            );
          }
        },

        {
          path: '/docs',
          name: 'DocsHome',
          meta: {
            label: 'Docs',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "DocsHome" */ '@/views/pages/knowledgebase/public/DocsHome'
            );
          }
        },
        {
          path: '/docs/article/:slug',
          name: 'ViewKnowledgeArticle',
          props: true,
          meta: {
            label: 'Docs Article',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "ViewKnowledgeArticle" */ '@/views/pages/knowledgebase/public/ViewKnowledgeArticle'
            );
          }
        },
        {
          path: '/docs/group/:slug',
          name: 'ViewKnowledgeGroup',
          props: true,
          meta: {
            label: 'Article Group',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "ViewKnowledgeGroup" */ '@/views/pages/knowledgebase/public/ViewKnowledgeGroup'
            );
          }
        },


        /* support */
        {
          path: '/support/tickets/external',
          name: 'Support.Tickets.External',
          meta: {
            label: 'External Tickets',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Support.Tickets.ExternalTickets" */ '@/views/pages/integrations/support/tickets/ExternalTickets'
            );
          }
        },
        {
          path: '/support/tickets/all',
          name: 'Support.Tickets.All',
          meta: {
            label: 'All Tickets',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Support.Tickets.All" */ '@/views/pages/integrations/support/tickets/Index'
            );
          }
        },
        {
          path: '/support/tickets/create',
          name: 'Support.Tickets.Create',
          meta: {
            label: 'Create a new Ticket',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Support.Tickets.Form" */ '@/views/pages/integrations/support/tickets/Form'
            );
          }
        },
        {
          path: '/support/tickets/view/:id',
          name: 'Support.Tickets.View',
          props: true,
          meta: {
            label: 'View Ticket',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Support.Tickets.Form" */ '../views/pages/integrations/support/tickets/Form.vue'
            );
          }
        },

        /* all user pages */
        {
          path: '/my-account',
          name: 'Common.MyAccount',
          meta: {
            label: 'My Account',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Common.MyAccount" */ '@/views/pages/common/MyAccount'
            );
          }
        },
        /* ./ all user pages */

        {
          path: '/dashboard',
          name: 'Dashboard',
          meta: {
            label: 'Dashboard',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Dashboard" */ '@/views/pages/integrations/support/tickets/Index'
            );
          }
        },
        {
          path: '/redirectSupport',
          name: 'Support.TicketsRedirect',
          meta: {
            label: 'Tickets',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Support.TicketsRedirect" */ '@/views/pages/common/TicketsRedirect'
            );
          }
        },

        //storefront/order-groups
        {
          path: '/admin/users',
          name: 'Admin.Manage.Users',
          meta: {
            label: 'Manage Users (SuperAdmins only)',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Manage.Users" */ '@/views/pages/admin/Users'
            );
          }
        },

      ]
    },

    {
      path: '*',
      name: 'Error 404',
      component: Page404
    }
  ];
}
let router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: configRoutes()
});
/* auth middleguard */
router.beforeEach((to, from, next) => {
  if (to.meta.authorized) {
    if (store.getters['account/isLoggedIn']) {
      next();
    } else {
      if (store.getters['account/getRefreshToken']) {
        store
          .dispatch(
            'account/refreshToken',
            store.getters['account/getRefreshToken']
          )
          .then(response => {
            store.dispatch('account/autoRefreshToken');
            next();
          })
          .catch(err => {
            console.error(err);
            localStorage.removeItem('refreshToken');
            //router.push('/');
            window.location.replace('/login?_r='+ (Math.random().toString(36).substr(2, 5)) +'&redirToUrl='+(location.pathname+location.search).substr(1));
          });
      } else {
        //router.push('/');
            window.location.replace('/login?_r='+ (Math.random().toString(36).substr(2, 5)) +'&redirToUrl='+(location.pathname+location.search).substr(1));
      }
    }
  } else {
    next();
  }
});

export default router;
